module.exports = __webpack_public_path__ + "img/705bb34.png";